import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TimelineTimestamp, TextClip, ClipDimensions} from "storyboard-renderer";
import {TimelineService} from "../../../timeline/timeline.service";
import {FormControl} from "@angular/forms";

@Component({
  selector: 'app-transcribe-sentence',
  templateUrl: './transcribe-sentence.component.html',
  styleUrls: ['./transcribe-sentence.component.scss']
})
export class TranscribeSentenceComponent implements OnInit {

  @Input() sentence: TextClip;
  @Input() sentenceIndex: number;
  @Output() onBreakSentence: EventEmitter<{newText: string, sentence: TextClip, sentenceIndex: number, cursorPosition: number}> = new EventEmitter<{newText: string, sentence: TextClip, sentenceIndex: number, cursorPosition: number}>();
  @Output() onDeleteSentence: EventEmitter<TextClip> = new EventEmitter<TextClip>();
  @Output() onOpenTextEditor: EventEmitter<TextClip> = new EventEmitter<TextClip>();
  @Output() onMergeSentence: EventEmitter<TextClip> = new EventEmitter<TextClip>();

  editing = false;
  sentenceFormControl: FormControl = new FormControl();
  @ViewChild('sentenceEditElement') sentenceEditElement: ElementRef;

  constructor(private timelineService: TimelineService) {

  }

  ngOnInit() {
    this.sentenceFormControl.patchValue(this.sentence.text);
  }

  seekTo() {
    this.timelineService.playerControl.seekTo(this.sentence.starts_at as TimelineTimestamp);
  }

  editSentence() {
    if(!this.editing) {
      this.editing = true;
      setTimeout(()=>{ // this will make the execution after the above boolean has changed
        this.sentenceEditElement.nativeElement.focus();
      },0);
    }
  }

  mergeWithNext() {
    this.onMergeSentence.emit(this.sentence);
  }

  breakSentence() {
    const cursorPosition = this.sentenceEditElement.nativeElement.selectionStart;

    // just save it
    if(!cursorPosition) {
      this.saveSentence();
      return;
    }

    const oldText = this.sentenceFormControl.value.substring(0, cursorPosition);
    const newText = this.sentenceFormControl.value.substring(cursorPosition);

    if(!newText) {
      this.saveSentence();
      return;
    }

    this.sentence.title = oldText;
    this.sentence.text = oldText;
    this.sentence.dimensions = new ClipDimensions();

    this.editing = false;

    this.onBreakSentence.emit({newText: newText, sentence: this.sentence, sentenceIndex: this.sentenceIndex, cursorPosition: cursorPosition});
  }

  saveSentence() {
    this.sentence.title =  this.sentenceFormControl.value;
    this.sentence.text =  this.sentenceFormControl.value;
    this.sentence.dimensions = new ClipDimensions();
    this.editing = false;

    this.timelineService.storyboardChangeEvent.next(true);
  }

  stopProp($event) {
    $event.stopPropagation();
  }

  deleteSentence() {
    this.onDeleteSentence.emit(this.sentence);
  }

  openTextEditor() {
    this.onOpenTextEditor.emit(this.sentence);
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/transcribe/transcribe-editor/transcribe-sentence/transcribe-sentence.component.ts